import { InputSelectModel } from './inputSelect.model';
import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.less']
})
export class InputSelectComponent implements OnInit {

  @Input() placeholder: string;
  @Input() validators: Array<string> = new Array<string>();
  @Input() children: Array<InputSelectModel> = new Array<InputSelectModel>();
  @Input() value: any;
  @Input() isAuth: boolean;

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() isInputValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  _validators: ValidatorFn[] = new Array<ValidatorFn>();
  isRequired: boolean;

  authInputFormControl: FormControl;

  ngOnInit() {
    this.validators.forEach((validator) => {
      if (validator === 'required') {
        this.isRequired = true;
        this._validators.push(Validators.required);
      }
    });

    if (this._validators.length === 0) {
      this.authInputFormControl = new FormControl('');
    } else {
      this.authInputFormControl = new FormControl('', this._validators);
      this.authInputFormControl.setValue(this.value);
      this.isValid();
    }
  }

  sendValue() {
    setTimeout(() => {
      this.authInputFormControl.updateValueAndValidity();
      this.isValid();
      this.valueChange.next(this.value);
    });
  }

  isValid() {
    this.isInputValid.next(this.authInputFormControl.valid);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input-select/input-select.component.ts